import { ID, StoreExecutorTable } from "@project/shared-types";
import { ChangeEvent, useEffect, useRef, useState } from "react";
import { UploadContentApi } from "../../entities/content/model/content.api";
import { InputNewImage } from "../InputNewImage/InputNewImage";

interface InputImageLoaderProps {
  size?: string;
  label?: string;
  placeholder?: string;
  description?: string;
  rightText?: string;
  focusStart?: boolean;
  validation?: () => string;
  errorMessage?: string;
  onLoad: (file_id: ID) => void;
  table_id: ID;
  table_type: StoreExecutorTable;
}

export const InputImageLoader: React.FC<InputImageLoaderProps> = ({
  ...props
}) => {
  const [file, setFile] = useState<File | null>(null);
  const [placeholder, setPlaceholder] = useState<string>("Прикрепить скриншот");
  const loading = useRef(false);
  useEffect(() => {
    const LoadFile = async () => {
      if (file) {
        setPlaceholder("Загрузка...");
        const res = await UploadContentApi(
          file,
          props.table_id,
          props.table_type
        );
        setFile(null);
        if (res.file_id) {
          props.onLoad(res.file_id);
          setPlaceholder("Скриншот прикреплен");
        } else {
          setPlaceholder("Ошибка загрузке");
        }
      }
    };
    if (file) {
      if (!loading.current) {
        loading.current = true;
        LoadFile();
        loading.current = false;
      }
    }
  }, [file]);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      setFile(event.target.files[0]);
    }
  };

  return (
    <InputNewImage
      placeholder={placeholder}
      value={file?.name ?? ""}
      onChange={handleChange}
    />
  );
};
